export const AUTH_BACKGROUND_STORAGE_KEY = 'provi_auth_backgrounds';

export const AUTH_ROLE_CONFIG = {
  client: {
    label: 'Cliente',
    loginTitle: 'Bienvenido de nuevo.',
    loginHighlight: 'Todo PROVI en un solo lugar.',
    registerTitle: 'Crea tu cuenta.',
    registerHighlight: 'Empieza en minutos.',
    subtitle: 'Taxi, delivery y comida en una sola app local. Verificamos tu correo para proteger tu cuenta.',
    chips: ['🚕 Taxi seguro', '🛵 Delivery', '🍔 Comida cerca'],
    mapBadge: '⚡ Servicios cerca de ti',
    eyebrow: 'App local inteligente'
  },
  provider: {
    label: 'Proveedor',
    loginTitle: 'Conecta con clientes.',
    loginHighlight: 'Trabaja con PROVI.',
    registerTitle: 'Regístrate como proveedor.',
    registerHighlight: 'Empieza a trabajar.',
    subtitle: 'Recibe solicitudes, pedidos y oportunidades desde una sola plataforma local.',
    chips: ['📍 Clientes cerca', '💬 Ofertas claras', '🔐 Cuenta verificada'],
    mapBadge: '⚡ Servicios activos',
    eyebrow: 'Red PROVI'
  },
  taxi: {
    label: 'Taxista',
    loginTitle: 'Conecta con clientes.',
    loginHighlight: 'Trabaja con PROVI.',
    registerTitle: 'Regístrate como taxista.',
    registerHighlight: 'Recibe solicitudes cercanas.',
    subtitle: 'Negocia viajes, acepta ofertas y trabaja con mayor seguridad.',
    chips: ['🚕 Solicitudes cercanas', '💬 Ofertas claras', '🔐 Viajes verificados'],
    mapBadge: '🚕 Viajes disponibles',
    eyebrow: 'Taxi PROVI'
  },
  delivery: {
    label: 'Delivery',
    loginTitle: 'Gestiona tus entregas.',
    loginHighlight: 'Muévete con PROVI.',
    registerTitle: 'Regístrate como repartidor.',
    registerHighlight: 'Empieza a entregar.',
    subtitle: 'Recibe pedidos, revisa rutas y controla tus entregas desde tu panel.',
    chips: ['🛵 Entregas activas', '📍 Rutas claras', '💸 Ganancias visibles'],
    mapBadge: '🛵 Entregas cerca',
    eyebrow: 'Delivery PROVI'
  },
  local: {
    label: 'Restaurante',
    loginTitle: 'Administra tu negocio.',
    loginHighlight: 'Vende con PROVI.',
    registerTitle: 'Registra tu restaurante.',
    registerHighlight: 'Recibe pedidos online.',
    subtitle: 'Gestiona pedidos, menú y ventas desde un solo lugar.',
    chips: ['🍔 Pedidos', '🧾 Menú', '📦 Ventas'],
    mapBadge: '🍔 Clientes cerca',
    eyebrow: 'Comida PROVI'
  },
  business: {
    label: 'Empresa',
    loginTitle: 'Administra tu negocio.',
    loginHighlight: 'Crece con PROVI.',
    registerTitle: 'Registra tu empresa.',
    registerHighlight: 'Conecta con clientes.',
    subtitle: 'Publica servicios, recibe solicitudes y controla tu operación local.',
    chips: ['🏪 Negocio local', '📊 Control', '🧾 Ventas'],
    mapBadge: '🏪 Oportunidades cerca',
    eyebrow: 'Negocios PROVI'
  },
  admin: {
    label: 'Admin',
    loginTitle: 'Panel de control.',
    loginHighlight: 'Gestiona PROVI.',
    registerTitle: 'Acceso administrativo.',
    registerHighlight: 'Control seguro.',
    subtitle: 'Acceso administrativo para operar, revisar y proteger la plataforma.',
    chips: ['🛡️ Seguridad', '📊 Operación', '⚙️ Sistema'],
    mapBadge: '🛡️ Centro PROVI',
    eyebrow: 'Admin PROVI'
  }
};

export const DEFAULT_AUTH_BACKGROUNDS = {
  client: { image_url: '', opacity: 0.16, show_desktop: true, show_mobile: false },
  provider: { image_url: '', opacity: 0.16, show_desktop: true, show_mobile: false },
  taxi: { image_url: '', opacity: 0.16, show_desktop: true, show_mobile: false },
  delivery: { image_url: '', opacity: 0.16, show_desktop: true, show_mobile: false },
  local: { image_url: '', opacity: 0.16, show_desktop: true, show_mobile: false },
  business: { image_url: '', opacity: 0.16, show_desktop: true, show_mobile: false },
  admin: { image_url: '', opacity: 0.12, show_desktop: true, show_mobile: false }
};

export const normalizeAuthRole = (roleType) => {
  if (!roleType) return 'client';
  if (roleType === 'restaurant') return 'local';
  return AUTH_ROLE_CONFIG[roleType] ? roleType : 'provider';
};

export const getAuthRoleConfig = (roleType) => AUTH_ROLE_CONFIG[normalizeAuthRole(roleType)] || AUTH_ROLE_CONFIG.client;

export const readAuthBackgrounds = () => {
  if (typeof window === 'undefined') return DEFAULT_AUTH_BACKGROUNDS;
  try {
    const saved = window.localStorage.getItem(AUTH_BACKGROUND_STORAGE_KEY);
    if (!saved) return DEFAULT_AUTH_BACKGROUNDS;
    const parsed = JSON.parse(saved);
    return Object.keys(DEFAULT_AUTH_BACKGROUNDS).reduce((acc, key) => {
      acc[key] = { ...DEFAULT_AUTH_BACKGROUNDS[key], ...(parsed[key] || {}) };
      return acc;
    }, {});
  } catch (error) {
    return DEFAULT_AUTH_BACKGROUNDS;
  }
};

export const saveAuthBackgrounds = (backgrounds) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(AUTH_BACKGROUND_STORAGE_KEY, JSON.stringify(backgrounds));
};

export const getAuthBackgroundForRole = (roleType, backgrounds = readAuthBackgrounds()) => (
  backgrounds[normalizeAuthRole(roleType)] || DEFAULT_AUTH_BACKGROUNDS.client
);
